export default "/images/Pigments_Dyes.webp?1b0c669381f6ae63edad52083ecc0eae";